module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-input', {
    ref: "input",
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": function($event) {
        return _vm.updateValue()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.error))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53f72380"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/input.vue
// module id = 1285
// module chunks = 160